import React, { useState, useEffect } from "react";
import { Button, Form, Modal, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import axios from "axios";

function CancelInvoiceModal({ showCancelModal, handleCancelModalClose, handleConfirmCancel, cancelInvoiceNumber }) {
    const { t } = useTranslation();
    const [isRequestButtonDisabled, setIsRequestButtonDisabled] = useState(false);
    const [isAlreadyRequested, setIsAlreadyRequested] = useState(false);
    const [isPrivateCustomer, setIsPrivateCustomer] = useState(false);

    useEffect(() => {
        const checkCancellationRequest = async () => {
            try {
                const response = await axios.get(`/InvoiceEdit/is-cancelation-request-created/${cancelInvoiceNumber}`);
                const { isCancelationRequestCreated, isPrivateCustomer } = response.data;
                setIsAlreadyRequested(isCancelationRequestCreated);
                setIsPrivateCustomer(isPrivateCustomer);
                setIsRequestButtonDisabled(isCancelationRequestCreated || !isPrivateCustomer);
            } catch (error) {
                console.error("Error checking cancellation request:", error);
            }
        };

        if (cancelInvoiceNumber) {
            checkCancellationRequest();
        }
    }, [cancelInvoiceNumber]);

    const confirmCancel = async () => {
        try {
            await axios.get(`/invoiceEdit/invoice-cancelation-request/${cancelInvoiceNumber}`);
            handleConfirmCancel();
            setIsRequestButtonDisabled(true);
        } catch (error) {
            console.error("Error cancelling the invoice:", error);
        }
    };

    return (
        <Modal show={showCancelModal} onHide={handleCancelModalClose}>
            <Modal.Header closeButton>
                <Modal.Title>{t("Request cancellation")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isPrivateCustomer ? (
                    isAlreadyRequested ? (
                        <p>{t("Cancellation request already created.")}</p>
                    ) : (
                        <p>
                            {t("Are you sure you want to proceed with the cancellation request for this invoice")} #{cancelInvoiceNumber}?
                        </p>
                    )
                ) : (
                    <p>{t("Cancellation is only available for private customers.")}</p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCancelModalClose}>
                    {(!isPrivateCustomer || (isPrivateCustomer && isAlreadyRequested)) ? t("Close") : t("No")}
                </Button>
                {isPrivateCustomer && !isAlreadyRequested && (
                    <Button
                        variant="primary"
                        onClick={confirmCancel}
                        disabled={isRequestButtonDisabled}
                    >
                        {t("Yes")}
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
}

export default CancelInvoiceModal;
